'use strict';

module.exports = 'Boolean Number String Date RegExp Function Array Error Set Map';


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/var/NATIVE_TYPES.js
// module id = 61
// module chunks = 0